import React, {useEffect, useRef, useState} from "react";
import {AutoComplete, Flex, Input, InputRef, Space, Tag, theme, Tooltip} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {Tag as TagField} from "../feature/project/fields";

export const TagFlow = (props: { allTags: TagField[], tags: TagField[], onTagAdded: (tag: TagField) => void, onTagDeleted: (tag: TagField) => void }) => {
    const {token} = theme.useToken();
    const [tags, setTags] = useState<TagField[]>(props.tags);
    const [inputVisible, setInputVisible] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [editInputIndex, setEditInputIndex] = useState(-1);
    const [editInputValue, setEditInputValue] = useState('');
    const inputRef = useRef<InputRef>(null);
    const editInputRef = useRef<InputRef>(null);

    useEffect(() => {
        setTags(props.tags)
    }, [props.tags]);

    useEffect(() => {
        if (inputVisible) {
            inputRef.current?.focus();
        }
    }, [inputVisible]);

    useEffect(() => {
        editInputRef.current?.focus();
    }, [editInputValue]);

    const handleClose = (removedTag: TagField) => {
        const newTags = tags.filter((tag) => tag !== removedTag);
        props.onTagDeleted(removedTag);
        setTags(newTags);
    };

    const showInput = () => {
        setInputVisible(true);
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    };

    const handleInputConfirm = () => {
        if (inputValue && !tags.map((item) => item.title).includes(inputValue)) {
            props.onTagAdded(props.allTags.find((item) => item.title == inputValue) || {title: inputValue});
        }
        setInputVisible(false);
        setInputValue('');
    };

    const handleEditInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEditInputValue(e.target.value);
    };

    const handleEditInputConfirm = () => {
        const newTags = [...tags];
        newTags[editInputIndex] = {id: -1, title: editInputValue};
        setTags(newTags);
        setEditInputIndex(-1);
        setEditInputValue('');
    };

    const tagPlusStyle: React.CSSProperties = {
        height: 22,
        background: token.colorBgContainer,
        borderStyle: 'dashed',
    };

    const tagInputStyle: React.CSSProperties = {
        width: 64,
        height: 22,
        verticalAlign: 'top',
    };

    return (
        <Flex wrap="wrap" gap={4}>
            {props.tags.map<React.ReactNode>((tag, index) => {
                if (editInputIndex === index) {
                    return (
                        <Input
                            ref={editInputRef}
                            key={tag.title}
                            size="small"
                            style={tagInputStyle}
                            value={editInputValue}
                            onChange={handleEditInputChange}
                            onBlur={handleEditInputConfirm}
                            onPressEnter={handleEditInputConfirm}
                        />
                    );
                }
                const isLongTag = tag.title.length > 20;
                const tagElem = (
                    <Tag
                        key={tag.title}
                        closable={true}
                        style={{userSelect: 'none', marginInlineEnd: 0}}
                        onClose={() => handleClose(tag)}
                    >
                        {isLongTag ? `${tag.title.slice(0, 20)}...` : tag.title}
                    </Tag>
                );
                return isLongTag ? (
                    <Tooltip title={tag.title} key={tag.title}>
                        {tagElem}
                    </Tooltip>
                ) : (
                    tagElem
                );
            })}
            {inputVisible ? (
                <AutoComplete
                    style={{height: 22}}
                    popupMatchSelectWidth={200}
                    options={props.allTags.map((tag) => ({value: tag.title, key: tag.id}))}
                    filterOption={(inputValue, option) =>
                        option!.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                    onSelect={(e) => setInputValue(e)}
                >
                    <Input
                        ref={inputRef}
                        type="text"
                        size="small"
                        style={tagInputStyle}
                        value={inputValue}
                        onChange={handleInputChange}
                        onBlur={handleInputConfirm}
                        onPressEnter={handleInputConfirm}
                    />
                </AutoComplete>
            ) : (

                <Tag style={tagPlusStyle} onClick={showInput}>
                    <Space size={4}><FontAwesomeIcon icon={faPlus}/> New Tag</Space>
                </Tag>

            )}
        </Flex>
    );
}